<kort-samling>
  <gruppe-sakstyper [gruppeId]="gruppe().id"/>
  <gruppe-roller [gruppeId]="gruppe().id"/>
  <gruppe-temaer [gruppeId]="gruppe().id"/>
  <aarshjul-oppsett [gruppeId]="gruppe().id"/>
  @if (gruppe().aksjeeierbokId !== null) {
    <aksjeklasser [aksjeeierbokId]="gruppe().aksjeeierbokId!"/>
  }
  <gruppe-protokoll-oppsett [gruppe]="gruppe()"/>
</kort-samling>
